import { createPinia } from 'pinia'

import { createPersistedStatePlugin } from '@/stores/plugins/persistedState'

export const pinia = createPinia()

pinia.use(createPersistedStatePlugin())
